// src/components/battle/BattlePageHeader.jsx
import BackButton from "../common/BackButton";

export default function BattlePageHeader({
  title,
  showBack = false,
  backButtonProps = {},
}) {
  return (
    // ✅ 배경/라인은 유지하면서, 타이틀만 코스 헤더 타이포로 통일
    <header className="w-full bg-white  border-slate-200">
      <div className="flex items-center px-4 pt-6 pb-4">
        {/* 왼쪽 */}
        <div className="w-10 flex items-center justify-start">
          {showBack ? <BackButton {...backButtonProps} /> : null}
        </div>

        {/* 가운데 (코스 헤더 스타일 그대로) */}
        <h1 className="flex-1 text-2xl font-bold text-gray-800 text-center">
          {title}
        </h1>

        {/* 오른쪽 더미 */}
        <div className="w-10" />
      </div>
    </header>
  );
}
